import { render, staticRenderFns } from "./recently_recommend_courses.vue?vue&type=template&id=201c3afc&scoped=true&"
import script from "./recently_recommend_courses.vue?vue&type=script&lang=js&"
export * from "./recently_recommend_courses.vue?vue&type=script&lang=js&"
import style0 from "./recently_recommend_courses.vue?vue&type=style&index=0&id=201c3afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c3afc",
  null
  
)

export default component.exports